import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './css/MarketStatus.css';

const MarketStatus = ({config}) => {
  const [indicesData, setIndicesData] = useState([]);

  useEffect(() => {
    axios.get(`${config.PY_API_URL}/marketStatus`)
      .then((response) => {
        setIndicesData(response.data.marketState);
      })
      .catch((error) => {
        console.error('Error fetching market data:', error);
      });
  }, []);

  return (
    <div className="market-status-container">
      {indicesData.map((index, idx) => (
        <div>
            {(index.index && <>
                <div key={idx} className="market-card">
                    <h3>{index.index}</h3>
                    <p className="price">{index.last}</p>
                    <p className={`change ${index.percentChange > 0 ? 'up' : 'down'}`}>
                        {(index.variation && index.variation.toFixed(2))} ({index.percentChange}%)
                    </p>
                </div>
            </>)}
        </div>        
      ))}
    </div>
  );
};

export default MarketStatus;
